import {createSlice} from '@reduxjs/toolkit';

export const activityInitialState = {
  formData: {},
  activityTypes: {
    type: 'object',
    properties: {
      activityType: {
        type: 'string',
        helperText: '',
        errorMessage: 'This field is required',
        options: []
      }
    }
  },
  showError: false
};

const activitySlice = createSlice({
  name: 'activity',
  initialState: activityInitialState,
  reducers: {
    setActivityFormData: (state, action) => {
      const newState = {
        ...state,
        formData: action.payload
      };
      return newState;
    },
    setActivityTypes: (state, action) => {
      const newState = {
        ...state,
        activityTypes: action.payload
      };
      return newState;
    },
    resetActivityData: (state, action) => {
      const newState = {
        ...state,
        formData: action.payload
      };
      return newState;
    },
    setShowError: (state, action) => {
      const newState = {
        ...state,
        showError: action.payload
      };
      return newState;
    },
    setActivityDisplayData: (state, action) => {
      const {displayOrder, ...rest} = action.payload;
      const newFormData = {
        ...state.formData,
        ...rest
      };
      if (displayOrder !== undefined) {
        newFormData.displayOrder = displayOrder;
      }
      return {
        ...state,
        formData: newFormData
      };
    }
  }
});

export const {
  setActivityFormData,
  setActivityTypes,
  resetActivityData,
  setShowError,
  setActivityDisplayData
} = activitySlice.actions;

export const activitySliceReducer = activitySlice.reducer;
